module.exports = "<div class=\"header\">\n  <app-navigation></app-navigation>\n  <router-outlet></router-outlet>\n</div>\n"